import { Vue, i18n } from "Components/vue";

if (document.querySelector("#czech-post-map-pickup-el")) {
  import("Components/vue/mapPickup/index.vue").then((module) => {
    const initializeMap = () => {
      window.$_czechPostMapPickup = new Vue({
        i18n,
        render: (h) =>
          h(module.default, {
            props: {
              branchesData: window.czechPostMapPickupBranchesData,
              $modalInstance: $("#czech-post-map-pickup-modal"),
              mapTrigger: document.querySelector("[r-czech-post-trigger]"),
              pickupInput: document.querySelector("input[r-czech-post-input]"),
              branchEmptyEl: document.querySelector("[r-czech-post-empty]"),
              branchSelectedEl: document.querySelector(
                "[r-czech-post-selected]"
              ),
              branchNameEl: document.querySelector(
                "[r-czech-post-selected-branch]"
              ),
              branchAddressEl: document.querySelector(
                "[r-czech-post-selected-address]"
              ),
              markerBorderColor: "#F6A620",
              markerIcons: {
                your_location: {
                  url: "/img/markers/your_location.svg",
                  size: [50, 50],
                  anchor: { left: 25, top: 25 },
                },
                normal: {
                  url: "/img/markers/czech_post.svg",
                  size: [56, 68],
                  anchor: { left: 28, top: 54 },
                },
                selected: {
                  url: "/img/markers/czech_post_selected.svg",
                  size: [56, 68],
                  anchor: { left: 28, top: 54 },
                },
              },
            },
          }),
      }).$mount("#czech-post-map-pickup-el");
    };

    // For some reason, the data is not always available immediately
    if (window.czechPostMapPickupBranchesData) {
      initializeMap();
    } else {
      const initializeMapInterval = setInterval(() => {
        if (window.czechPostMapPickupBranchesData) {
          clearInterval(initializeMapInterval);
          initializeMap();
        }
      }, 150);
    }
  });
}
